import { Box, Typography } from '@mui/material';
import { useTranslation } from '../../../hooks/useTranslation';

interface LiveSyncStatusProps {
  isUpdating: boolean;
  secondsSinceUpdate: number;
}

const LiveSyncStatus: React.FC<LiveSyncStatusProps> = ({
  isUpdating,
  secondsSinceUpdate,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      role="status"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        mb: 1.25,
        px: 1.15,
        py: 0.45,
        borderRadius: 999,
        bgcolor: '#EEF4FF',
        border: '1px solid rgba(33, 71, 246, 0.15)',
      }}
    >
      <Box
        aria-hidden
        sx={{
          width: 9,
          height: 9,
          borderRadius: '50%',
          bgcolor: '#16A34A',
          boxShadow: '0 0 0 rgba(22, 163, 74, 0.55)',
          animation: 'livePulse 1.8s ease-out infinite',
          '@keyframes livePulse': {
            '0%': { boxShadow: '0 0 0 0 rgba(22, 163, 74, 0.55)' },
            '70%': { boxShadow: '0 0 0 10px rgba(22, 163, 74, 0)' },
            '100%': { boxShadow: '0 0 0 0 rgba(22, 163, 74, 0)' },
          },
        }}
      />
      <Typography
        sx={{ fontSize: '0.82rem', fontWeight: 600, color: '#1E3A8A' }}
      >
        {isUpdating
          ? t('Live sync: updating...')
          : t('Live sync: updated {{seconds}}s ago', {
              seconds: secondsSinceUpdate,
            })}
      </Typography>
    </Box>
  );
};

export default LiveSyncStatus;
